import {
  ChangeDetectorRef,
  Component,
  Input,
  OnChanges,
  OnInit,
  SimpleChanges,
} from "@angular/core";
import { ActivatedRoute, NavigationEnd, Router } from "@angular/router";
import { filter, lastValueFrom } from "rxjs";
import { CacheService } from "src/app/services/cache.service";
import { FeatureService } from "src/app/services/features.service";
import { NetworkService } from "src/app/services/network.service";

@Component({
  selector: "app-footer",
  templateUrl: "./footer.component.html",
  styleUrls: ["./footer.component.scss"],
})
export class FooterComponent implements OnInit, OnChanges {
  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private cdr: ChangeDetectorRef,
    public featureService: FeatureService,
    private cacheService: CacheService,
    private networkService: NetworkService
  ) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.featureBaseUrl) {
      this.getFooterIcons();
    }
  }

  @Input() featureBaseUrl: string;

  currentRoute = "";
  footerIcons;
  defaultPath;
  homeIconData = {
    defaultPath: "/home",
    footerIcons: [
      {
        isSelected: false,
        iconSrc: "/assets/redesign/home/home-icon.svg",
        negIconSrc: "/assets/redesign/home/home-neg-icon.svg",
        name: "Home",
      },
    ],
  };

  ngOnInit(): void {
    this.router.events;
    // .pipe(filter((event) => event instanceof NavigationEnd))
    // .subscribe((event: NavigationEnd) => {
    this.updateCurrentRoute(this.router.url);
    this.addIcons();
    //this.cdr.detectChanges();
    // });
    this.getFooterIcons();
  }

  updateCurrentRoute(temp) {
    this.currentRoute = temp;
  }

  getCurrentRoute() {
    return this.currentRoute;
  }

  getHomeIconData() {
    return this.homeIconData;
  }

  getHomeIsSelected() {
    return this.homeIconData.footerIcons[0].isSelected;
  }

  updateHomeIconData(isSelected): void {
    this.homeIconData.footerIcons[0].isSelected = isSelected;
  }

  isCurrentRouteHome() {
    return this.currentRoute === "/home";
  }

  doesCurrentRouteMatch(url) {
    const navigationParam =
      this.route.snapshot.queryParamMap.get("navigationParam");

    return navigationParam === url;
  }

  setIsHomeSelected() {
    if (this.currentRoute === "/home") {
      this.updateHomeIconData(true);
    } else {
      this.updateHomeIconData(false);
    }
  }

  addIcons() {
    this.setIsHomeSelected();

    const footer = document.getElementById("footer");

    function addFooterIcon(fi) {
      const iconDiv = document.createElement("div");
      iconDiv.classList.add("footer-icon");
      footer.appendChild(iconDiv);
    }
  }

  getFooterIcons() {
    console.log("Footer: " + this.featureBaseUrl);
    this.featureService
      .getFeatureDescriptionByBaseUrl(this.featureBaseUrl)
      .then((rslt) => {
        console.log(rslt);
        if (rslt) {
          this.defaultPath = rslt.defaultPath;
          this.footerIcons = rslt.footerIcons;
        }
      });
  }

  public iconUrlMap: { [key: string]: string } = {};

  async getIconSrc(fi: any): Promise<void> {
    const iconUrl = `${this.featureBaseUrl}${fi.iconSrc}`;
    let computedUrl: string = "";

    const img = await lastValueFrom(
      this.cacheService.getResource(iconUrl, true)
    );
    console.log("Footer icon", img);

    // now destructure into `data` and `content`
    const data = img.data;

    if (data) {
      console.log(`Footer icon data: ${JSON.stringify(data)}`);
      if (typeof data === "string" && data.startsWith("data:image")) {
        computedUrl = data;
        // } else if (img instanceof Blob) {
        //   computedUrl = URL.createObjectURL(img);
      } else {
        computedUrl = data as string;
      }
      console.log(`Setting iconUrlMap: ${JSON.stringify(computedUrl)}`);
      this.iconUrlMap[iconUrl] = computedUrl;
    } else {
      computedUrl = "";
    }

    // Trigger change detection to update UI when icon is loaded
    this.cdr.markForCheck();
  }

  getIcon(fi: any): string {
    const iconUrl = `${this.featureBaseUrl}${fi.iconSrc}`;
    if (!this.iconUrlMap[iconUrl]) {
      // Trigger asynchronous load if not in cache
      this.getIconSrc(fi);
      return "";
    }
    console.log(
      `GET Footer icon data: ${JSON.stringify(this.iconUrlMap[iconUrl])}`
    );
    const data = this.iconUrlMap[iconUrl];
    return "data:image/svg+xml;utf8," + encodeURIComponent(data);
  }

  public negIconUrlMap: { [key: string]: string } = {};

  async getNegIconSrc(fi: any): Promise<void> {
    const iconUrl = `${this.featureBaseUrl}${fi.negIconSrc}`;
    let computedUrl: string = "";

    const img = await lastValueFrom(
      this.cacheService.getResource(iconUrl, true)
    );
    console.log("Footer neg icon", img);

    // now destructure into `data` and `content`
    const data = img.data;

    if (data) {
      console.log(`Footer neg icon data: ${JSON.stringify(data)}`);
      if (typeof data === "string" && data.startsWith("data:image")) {
        computedUrl = data;
        // } else if (img instanceof Blob) {
        //   computedUrl = URL.createObjectURL(img);
      } else {
        computedUrl = data as string;
      }

      console.log(`Setting negIconUrlMap: ${JSON.stringify(computedUrl)}`);
      this.negIconUrlMap[iconUrl] = computedUrl;
    } else {
      computedUrl = "";
    }
    // Trigger change detection
    this.cdr.markForCheck();
  }

  getNegIcon(fi: any): string {
    const iconUrl = `${this.featureBaseUrl}${fi.negIconSrc}`;
    if (!this.negIconUrlMap[iconUrl]) {
      this.getNegIconSrc(fi);
      return "";
    }
    console.log(
      `GET Footer neg icon data: ${JSON.stringify(this.negIconUrlMap[iconUrl])}`
    );
    const data = this.negIconUrlMap[iconUrl];
    return "data:image/svg+xml;utf8," + encodeURIComponent(data);
  }

  onImageError() {
    console.error("Image failed to load!!!!!!!!!!!");
    this.networkService
      .checkInternetConnection()
      .then((isConnected) => {
        if (isConnected) {
          console.log("Internet is active");
        } else {
          this.networkService.markInternetDown();
        }
      })
      .catch((error) =>
        console.error("Unexpected error in connectivity check:", error)
      );
  }

  navigateToFeature(path: string, queryParam): void {
    if (queryParam) {
      this.router.navigateByUrl("/", { skipLocationChange: true }).then(() => {
        this.router.navigate(["/react-native", path.replace(/\//g, "")], {
          queryParams: { navigationParam: queryParam },
        });
      });
    } else {
      this.router.navigate([path]);
    }
  }
}
